<template>
	<v-dialog v-model="dialogDetail" persistent max-width="80%" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 secondary--text">Detail Riwayat Kirim Serial</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pb-0 pt-4">
				<v-row v-if="dataHistory.length > 0">
					<v-col cols="12" class="pt-0" v-if="!loading">
						<v-data-table dense hide-default-footer :loading="loading" loading-text="Sedang memuat data..." disable-sort :headers="table_headers" :items="detailHistorySerialList" :items-per-page="parseInt(limit)" class="table-vo" no-data-text="Tidak ada data tersedia">
							<template v-slot:[`item.date`]="{ item }">
								{{ item.serial_transfer_log_serial_datetime | toDateHour }}
							</template>
							<template v-slot:[`item.serial`]="{ item }">
								<div class="cl-primary font-weight-500">{{ item.serial_transfer_log_serial_id }}</div>
							</template>
							<template v-slot:[`item.type`]="{ item }">
								<div class="green--text" v-if="item.serial_transfer_log_serial_status == 'in'">Masuk</div>
								<div class="red--text" v-else>Keluar</div>
							</template>
							<template v-slot:[`item.sender`]="{ item }">
								<div v-if="item.serial_transfer_log_serial_sender_administrator_id == '1'">Admin</div>
								<div v-else>{{ item.serial_transfer_log_serial_sender_member_name }}</div>
							</template>
							<template v-slot:[`item.receiver`]="{ item }">
								{{ item.serial_transfer_log_serial_receiver_member_name }}
							</template>
						</v-data-table>
					</v-col>
					
					<v-col cols="12" class="pt-0" v-else>
						<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
							<div class="pt-3 text-center cl-secondary">Sedang memuat data riwayat serial...</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="detailHistorySerialList.length <= 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada riwayat serial yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="detailHistorySerialList.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="detailHistorySerialPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ detailHistorySerialPagination.total_display }} data dari total {{ detailHistorySerialPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-select :items="limit_list" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="primary" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions class="justify-center py-5">
				<v-btn depressed color="grey" outlined class="dark--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="modalHide">
					<span class="px-3">Tutup</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
	data () {
		return {
			dialogDetail: false,
			loading: true,
			btnLoadingProses: false,
			networkCode: '',
			serialType: '',
			page: 1,
			limit: '10',
			limit_list: [ '10', '20', '50', '100' ],
			params: [],
			dataHistory: [],
			table_headers: [
				{ text: 'Tanggal', width: '20%', align: 'start', value: 'date' },
				{ text: 'Serial', width: '20%', align: 'start', value: 'serial' },
				{ text: 'Tipe', width: '20%', align: 'start', value: 'type' },
				{ text: 'Pengirim', width: '20%', align: 'start', value: 'sender' },
				{ text: 'Penerima', width: '20%', align: 'start', value: 'receiver' },
			]
		}
	},
	computed: {
		...mapState('serial', ['detailHistorySerialList', 'detailHistorySerialPagination']),
	},
	methods :{
		...mapActions('serial', ['getDetailHistorySerialList']),

		async modalShow(serial_id, member_id) {
			this.loading = await true
			this.serialType = await serial_id
			this.networkCode = await member_id
			this.dialogDetail = await true

			const params = await this.queryString({ limit:this.limit, page: this.page, network_code: this.networkCode, sort: 'serial_transfer_log_serial_datetime', dir: 'desc' })
			let data = await {
				id: this.serialType,
				params: params
			}
			this.getDetailHistorySerialList(data).then((res) => {
				this.dataHistory = res.results
			})

			setTimeout(() => {
				this.loading = false
			}, 1000);
		},
		modalHide() {
			this.dialogDetail = false
			this.btnLoadingProses = false
			this.dataHistory = []
		},
		reset() {
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		async getData() {
			this.loading = await true
			const params = await this.queryString({ limit:this.limit, page: this.page, network_code: this.networkCode, sort: 'serial_transfer_log_serial_datetime', dir: 'desc' })
			let data = {
				id: this.serialType,
				params: params
			}
			
			this.getDetailHistorySerialList(data).then((res) => {
				this.dataHistory = res.results
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				setTimeout(() => {
					this.loading = false
				}, 1000);
			})
		},
	},
	mounted() {
	},
};
</script>